
module Meevo.Plugins.ClientApp {
    "use strict";
    import SettingsDto = Meevo.Model.SettingsDto;
    import ISelectItem = Meevo.Model.ISelectItem;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;


    /**
    * Preferences Section of BusinessInfo
    */

    export class CustomSettingsSection extends Meevo.Components.CommonClasses.SettingsSectionBase {
        public onlineBookingPlaceholderUrl = "https://meevo.com";
        public isOnlineBookingEnabled = false;
        public customButtonsSet: any;
        public copy: any;
        public auditNoun: Meevo.Model.NounEnum;

        public externalUrlRegex: string = "^((http|https)://)?[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$";

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected $q: ng.IQService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected basedataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string,
            protected context?: Meevo.Plugins.ClientApp.ClientAppContext,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.initializeData();
        }

        initializeData(): void {
            this.auditNoun = Meevo.Model.NounEnum.ClientAppCustomSettings;
            this.getSettings();

            this.context.setMode(Model.MaintenanceFormState.Readonly);
            this.mode = Model.MaintenanceFormState.Readonly;

            var scope = this;
            this.customButtonsSet = [
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppSettingsTab, Model.VerbEnum.EditButtonClicked, null, null);
                        scope.context.edit();
                        scope.mode = Model.MaintenanceFormState.Editing;
                        this.copy = angular.copy(this.model);
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.context.isApplicationModeCO() || this.identityService.isSingleLocation()) && this.mode == Model.MaintenanceFormState.Readonly,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppSettingsTab, Model.VerbEnum.SaveButtonClicked, null, null);
                        if (scope.saveSettings()) {
                            this.mode = Model.MaintenanceFormState.Readonly;
                        }
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.context.isApplicationModeCO() || this.identityService.isSingleLocation()) && this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppSettingsTab, Model.VerbEnum.CancelButtonClicked, null, null);
                        this.model = angular.copy(this.copy);
                        scope.context.setMode(Model.MaintenanceFormState.Readonly);
                        scope.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.context.isApplicationModeCO() || this.identityService.isSingleLocation()) && this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
            ];
        }

        isSingleLocation = (): boolean => {
            if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                return this.identityService.current().isSingleLocation;
            else
                return false;
        }

        getSettings() {
            this.dataService.customMethodData("api/ClientApp/Settings?includeMetadata=true", "GET", this.model).then((data) => {
                if (data.data) {
                    this.model = data.data;
                    this.model.clientsViewTermsAndConditionsType = 1;
                    this.model.clientsViewPrivacyPolicyType = 1;
                    this.loadImagesFromStorage();
                }
            });
        }

        activate(): void {
            super.activate();
            this.loadImagesFromStorage();
        }

        selected(): void {
            super.selected();

            if (this.model
                && this.model.splashScreenImage) {
                this.loadImagesFromStorage();
            }
        }

        saveSettings(): boolean {
            if (this.model
                && ( (this.model.allowClientsViewTermsAndConditions && this.model.clientsViewTermsAndConditionsType == 1 && (!this.model.clientsViewTermsAndConditionsWebPage || this.model.clientsViewTermsAndConditionsWebPage.length == 0))                    
                    || (this.model.allowClientsViewPrivacyPolicy && this.model.clientsViewPrivacyPolicyType == 1 && (!this.model.clientsViewPrivacyPolicyWebPage || this.model.clientsViewPrivacyPolicyWebPage.length == 0)))
            ) {
                this.modalService.alert("MESSAGE_CLIENTAPP_INVALID_SAVE");
                return false;
            }
            this.saveImages()
                .then(() => {
                    this.dataService.customMethodData("api/ClientApp/ClientAppSettings", "POST", this.model).then((data) => {
                        if (data.data) {
                            //TODO: GET Latest Data OR Refresh current Data With Return data Based on new SP Output
                            this.copy = angular.copy(this.model);
                        }
                    });
                });
            return true;
        }

        public saveImages(): ng.IPromise<void> {
            this.busyService.start();
            return this.$q.all([
                this.model.splashScreenObj ? this.saveImageToStorage(this.model.splashScreenObj) : this.$q.resolve(null)
            ]).then((response: Array<IStorageFile | any>) => {
                this.model.splashScreenImage = this.model.splashScreenObj.fileGuid;
            }).catch(error => {
                this.loggingService.trace(error.statusText);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        public saveImageToStorage(file: IStorageFile = {}): angular.IPromise<any> {
            if (!Object.keys(file).length) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData('/api/storage/customBrandingImage', 'POST', {
                customBrandingImageResource: _.extend(file, { resourceType: file.meevoFile['storageTypeEnum'], contentType: file.contentType })
            });
        }

        protected isImagesLoading: boolean = false;
        loadImagesFromStorage(): void {
            if (this.isImagesLoading) {
                return;
            }
            this.isImagesLoading = true;
            this.busyService.start();
            this.$q.all([
                this.getImageUrl(StorageTypeEnum.ClientCustomBrandedAppScreen, this.model.splashScreenImage)
            ]).then((responses) => {
                let splashScreenResp = responses[0] || {};
                this.model.splashScreenObj = splashScreenResp.data || {};
            }).finally(() => {
                this.busyService.stop();
                this.isImagesLoading = false;
            });
        }

        public getImageUrl(storageTypeEnum: StorageTypeEnum, fileGuid: Guid | string): angular.IPromise<any> {
            if (!fileGuid) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData(`/api/storage/customBrandingImage/${storageTypeEnum}/${fileGuid}`, 'GET', null);
        }

    }
}
